<template>
  <div v-cloak v-if="isStaff" class="container">
    <div class="title">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>设施运维</el-breadcrumb-item>
        <el-breadcrumb-item>工程服务</el-breadcrumb-item>
        <el-breadcrumb-item>技术改造</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="title-en">搜索条件</div>
    <el-card class="box-card">
      <div class="search-container">
        <el-form :inline="true" :model="searchForm" class="search-form" label-width="100px">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="创建日期">
                <el-date-picker
                  v-model="searchForm.create_time"
                  type="daterange"
                  range-separator="-"
                  style="width: 100%"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  @change="handleDateChange"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="项目类型">
                <el-select
                  clearable
                  v-model="searchForm.project_type"
                  placeholder="请选择"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in projectTypeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="项目名称">
                <el-input v-model="searchForm.project_name" placeholder="请输入项目名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="客户名称">
                <el-select
                  v-model="searchForm.customer_name"
                  placeholder="请选择"
                  clearable
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in customerOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <!-- <el-col :span="6">
              <el-form-item label="方案日期">
                <el-date-picker
                  v-model="searchForm.plan_date"
                  type="date"
                  style="width: 100%"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="清单日期">
                <el-date-picker
                  v-model="searchForm.list_date"
                  type="date"
                  style="width: 100%"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
            </el-col> -->
            <el-col :span="6">
              <el-form-item label="审核状态">
                <el-select clearable v-model="searchForm.audit_status" placeholder="请选择">
                  <el-option label="提交方案" value="提交方案"></el-option>
                  <el-option label="方案审核" value="方案审核"></el-option>
                  <el-option label="确认归档" value="确认归档"></el-option>
                  <el-option label="归档完成" value="归档完成"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建人">
                <el-input v-model="searchForm.creator" placeholder="请输入创建人"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="search-button">
                <el-button type="primary" @click="handleSearch">点击查询</el-button>
                <el-button @click="handleReset">重置</el-button>
                <el-button @click="debouncedExport">{{ exportButtonText }}</el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>
    <div class="title-en">技术改造</div>

    <el-card class="box-card">
      <div class="table-container">
        <div class="button-container">
          <div><el-button type="primary" @click="openCreateDrawer">创建项目</el-button></div>
          <div>
            <el-button @click="openColumnsDialog">表头设置</el-button>
          </div>
        </div>

        <el-drawer
          title="创建项目"
          :visible.sync="createDrawerVisible"
          direction="rtl"
          size="30%"
          :destroy-on-close="true"
        >
          <el-form
            :model="createForm"
            :rules="createFormRules"
            ref="createForm"
            class="create-form"
          >
            <el-form-item label="项目名称" prop="project_name">
              <el-input v-model="createForm.project_name" placeholder="请输入项目名称"></el-input>
            </el-form-item>
            <el-form-item label="项目类型" prop="project_type">
              <el-select
                v-model="createForm.project_type"
                placeholder="请选择项目类型"
                style="width: 100%"
              >
                <el-option
                  v-for="item in projectTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="客户名称" prop="customer_name">
              <el-select
                v-model="createForm.customer_name"
                placeholder="请选择客户名称"
                style="width: 100%"
                @change="handleCustomerChange"
              >
                <el-option
                  v-for="item in customerOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-input
                v-if="createForm.isCustomCustomer"
                v-model="createForm.customer_name"
                placeholder="请输入客户名称"
                style="margin-top: 10px"
              ></el-input>
            </el-form-item>
            <el-form-item label="审核人员" prop="auditor">
              <el-select
                v-model="createForm.auditor"
                placeholder="请选择审核人员"
                style="width: 100%"
              >
                <el-option label="周德明" value="周德明"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="方案负责人" prop="solution_manager">
              <el-input
                v-model="createForm.solution_manager"
                placeholder="请输入方案负责人"
              ></el-input>
            </el-form-item>
            <el-form-item label="项目负责人" prop="project_manager">
              <el-input
                v-model="createForm.project_manager"
                placeholder="请输入项目负责人"
              ></el-input>
            </el-form-item>
            <el-form-item label="项目地点" prop="project_location">
              <el-input
                v-model="createForm.project_location"
                placeholder="请输入项目地点"
              ></el-input>
            </el-form-item>
            <!-- <el-form-item label="方案日期" prop="plan_date">
              <el-date-picker
                v-model="createForm.plan_date"
                type="date"
                placeholder="选择日期"
                style="width: 100%"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="清单日期" prop="list_date">
              <el-date-picker
                v-model="createForm.list_date"
                type="date"
                placeholder="选择日期"
                style="width: 100%"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item> -->
            <el-form-item label="项目描述" prop="project_desc">
              <el-input
                type="textarea"
                v-model="createForm.project_desc"
                :rows="4"
                placeholder="请按以下格式填写：
1.需求简述；
2.客户技术/工勘联系人及电话
3.期望日期"
              ></el-input>
              <div class="form-tip">
                <div class="tip-header">
                  <i class="el-icon-info"></i>
                  <span>格式要求</span>
                </div>
                <div class="tip-content">
                  <div class="tip-item">
                    <span class="tip-number">1.</span>
                    <span class="tip-text">需求简述</span>
                  </div>
                  <div class="tip-item">
                    <span class="tip-number">2.</span>
                    <span class="tip-text">客户技术/工勘联系人及电话</span>
                  </div>
                  <div class="tip-item">
                    <span class="tip-number">3.</span>
                    <span class="tip-text">期望日期</span>
                  </div>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="附件" prop="attachments">
              <el-upload
                class="upload-demo"
                action="#"
                :http-request="handleUpload"
                :on-success="handleUploadSuccess"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :before-remove="beforeRemove"
                :limit="3"
                :on-exceed="handleExceed"
                :file-list="createForm.attachments"
              >
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">文件大小不超过50MB</div>
              </el-upload>
            </el-form-item>
          </el-form>
          <div class="drawer-footer">
            <el-button @click="createDrawerVisible = false">取 消</el-button>
            <el-button type="primary" @click="submitCreateForm">确 定</el-button>
          </div>
        </el-drawer>
        <el-table
          :data="projects"
          border
          stripe
          @selection-change="handleSelectionChange"
          ref="table"
          v-loading="loading"
        >
          <el-table-column prop="operation" label="操作" width="70" fixed="right" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                :disabled="scope.row.auditor !== loginName"
                @click="handleDelete(scope.row)"
                :style="{
                  color: scope.row.auditor !== loginName ? '#C0C4CC' : '#F56C6C',
                }"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
          <el-table-column type="selection" width="55" align="center"></el-table-column>
          <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
          <el-table-column prop="project_name" label="项目名称" width="100">
            <template slot-scope="scope">
              <el-link
                type="primary"
                :underline="false"
                @click="
                  $router.push({ name: 'technicalReformDetail', query: { id: scope.row.id } })
                "
              >
                {{ scope.row.project_name }}
              </el-link>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="project_desc" label="项目描述" width="150" align="center">
            <template slot-scope="scope">
              <el-popover
                placement="top-start"
                width="300"
                trigger="hover"
                popper-class="project-desc-popover">
                <div style="white-space: pre-line;">{{ scope.row.project_desc }}</div>
                <span slot="reference" class="project-desc-text">{{ scope.row.project_desc }}</span>
              </el-popover>
            </template>
          </el-table-column> -->

          <!-- <el-table-column prop="project_desc" label="项目描述" width="200" align="left">
            <template slot-scope="scope">
              <div style="white-space: pre-line; padding: 8px 0">{{ scope.row.project_desc }}</div>
            </template>
          </el-table-column> -->

          <el-table-column
            v-for="(column, index) in visibleColumns"
            :key="index"
            :prop="column.prop"
            :label="column.label"
            :width="column.width"
          >
            <template slot-scope="scope">
              <span v-if="column.prop === 'project_type'">{{ scope.row[column.prop] || '-' }}</span>
              <span v-else-if="column.prop === 'remark'">
                <div class="remark-container">
                  <template v-if="scope.row.isEditing">
                    <el-input
                      v-model="scope.row.remark"
                      size="small"
                      @blur="handleRemarkUpdate(scope.row)"
                      placeholder="请输入备注"
                    ></el-input>
                  </template>
                  <template v-else>
                    <span>{{ scope.row.remark || '-' }}</span>
                    <el-button type="text" size="mini" @click="handleEditRemark(scope.row)">
                      <i class="el-icon-edit"></i>
                    </el-button>
                  </template>
                </div>
              </span>
              <span v-else-if="column.prop === 'audit_status'">
                <el-tag
                  :type="
                    scope.row.operation_type === 'submit'
                      ? 'info'
                      : scope.row.operation_type === '6'
                      ? 'warning'
                      : scope.row[column.prop] === '待审核'
                      ? 'info'
                      : scope.row[column.prop] === '已通过'
                      ? 'success'
                      : scope.row[column.prop] === '已驳回'
                      ? 'danger'
                      : ''
                  "
                  size="small"
                >
                  {{
                    scope.row.audit_status === 'submit'
                      ? '方案提交'
                      : scope.row.audit_status === '6'
                      ? '更新项目'
                      : scope.row.audit_status === '3'
                      ? '方案提交'
                      : scope.row[column.prop] || '-'
                  }}
                </el-tag>
              </span>
              <span
                v-else-if="
                  ['create_time', 'plan_date', 'list_date', 'modify_date'].includes(column.prop)
                "
                >{{
                  scope.row[column.prop]
                    ? $moment(scope.row[column.prop]).format('YYYY-MM-DD')
                    : '-'
                }}</span
              >
              <!-- <span v-else-if="column.prop === 'attachments'">
                <div
                  v-if="scope.row.attachments && scope.row.attachments.length"
                  class="attachment-container"
                >
                  <div class="attachment-cards">
                    <div
                      v-for="(file, index) in scope.row.attachments"
                      :key="index"
                      class="attachment-card"
                    >
                      <div class="file-icon">
                        <i class="el-icon-document"></i>
                      </div>
                      <div class="file-info">
                        <el-tooltip :content="file.file_name" placement="top" :hide-after="2000">
                          <div class="file-name" @click="handleFileDownload(file)">
                            {{ file.file_name }}
                          </div>
                        </el-tooltip>
                        <div class="file-actions">
                          <el-button type="text" size="mini" @click="handleFileDownload(file)">
                            <i class="el-icon-download"></i> 下载
                          </el-button>
                          <el-button type="text" size="mini" @click="handleFileSaveAs(file)">
                            <i class="el-icon-folder-add"></i> 另存为
                          </el-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <span v-else class="no-attachment">-</span>
              </span> -->
              <span v-else>{{ scope.row[column.prop] || '-' }}</span>
            </template>
          </el-table-column>
        </el-table>

        <el-dialog
          title="设置显示项"
          :visible.sync="showColumnsDialog"
          :append-to-body="true"
          width="400px"
          :close-on-click-modal="false"
          custom-class="columns-dialog"
          :modal-append-to-body="false"
          :destroy-on-close="true"
        >
          <el-checkbox-group v-model="selectedColumns" class="checkbox-group">
            <el-checkbox
              v-for="column in columns"
              :key="column.prop"
              :label="column.prop"
              class="checkbox-item"
            >
              {{ column.label }}
            </el-checkbox>
          </el-checkbox-group>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="selectAllColumns">全选</el-button>
            <el-button size="small" @click="restoreDefaultColumns">恢复默认</el-button>
            <el-button size="small" type="primary" @click="saveColumnsDialog">保存</el-button>
          </div>
        </el-dialog>

        <div class="pagination-container">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          />
        </div>
      </div>
    </el-card>
    <el-dialog
      title="确认删除"
      :visible.sync="deleteDialogVisible"
      width="30%"
      :close-on-click-modal="false"
    >
      <span>确定要删除该项目吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialogVisible = false">取 消</el-button>
        <el-button type="danger" @click="confirmDelete">确 定</el-button>
      </span>
    </el-dialog>
  </div>
  <div v-else class="empty-state">
    <el-empty description="暂无权限查看此页面"></el-empty>
  </div>

  <!-- 删除原有的Dialog组件 -->
</template>

<style scoped>
[v-cloak] {
  display: none;
}
.empty-state {
  display: flex;
  justify-content: center;
  align-items: center;
}
.project-desc-text {
  display: inline-block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.project-desc-popover {
  max-width: 400px;
  line-height: 1.5;
  font-size: 14px;
}
.form-tip {
  margin-top: 10px;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  background-color: #fafafa;
}
.tip-header {
  padding: 8px 12px;
  background-color: #f5f7fa;
  border-bottom: 1px solid #e6e6e6;
  display: flex;
  align-items: center;
  font-size: 13px;
  color: #606266;
}
.tip-header i {
  margin-right: 6px;
  color: #409eff;
}
.tip-content {
  padding: 12px;
}
.tip-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 8px;
  font-size: 13px;
  color: #606266;
  line-height: 1.4;
}
.tip-item:last-child {
  margin-bottom: 0;
}
.tip-number {
  margin-right: 6px;
  color: #409eff;
  font-weight: bold;
}
.tip-text {
  flex: 1;
}
.remark-container {
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>
        
        <script>
import {
  getTechnicalReformList,
  createTechnicalReform,
  getTechnicalReformListAll,
  deleteTechnicalReform,
  updateTechnicalReformRemark,
} from '@/api/skill';
import { getStaffInfo } from '@/api/staff';
import * as XLSX from 'xlsx';
import { debounce } from 'lodash';
import axios from 'axios';
export default {
  name: 'FaultList',
  data() {
    return {
      loginName: '',
      createDrawerVisible: false,
      deleteDialogVisible: false,
      maxFileSize: 10,
      createForm: {
        project_name: '',
        project_type: '',
        customer_name: '',
        project_location: '',
        plan_date: '',
        list_date: '',
        project_desc: '',
        attachments: [],
        filename: '',
        operation_status: '待处理',
        operation_flag: '未处理',
        isCustomCustomer: false,
        auditor: '',
        solution_manager: '',
        project_manager: '',
      },

      columns: [
        { prop: 'project_name', label: '项目名称', width: '100' },
        { prop: 'project_type', label: '项目类型', width: '120' },
        { prop: 'customer_name', label: '客户名称', width: '120' },
        { prop: 'project_location', label: '项目地点', width: '120' },
        { prop: 'project_desc', label: '项目描述', width: '200' },
        { prop: 'remark', label: '备注', width: '150' },
        { prop: 'audit_status', label: '审核状态', width: '100' },
        { prop: 'creator', label: '创建人', width: '100' },
        { prop: 'solution_manager', label: '方案负责人', width: '100' },
        { prop: 'project_manager', label: '项目负责人', width: '100' },
        { prop: 'create_time', label: '创建时间', width: '120' },
        { prop: 'auditor', label: '审核人', width: '100' },
      ],
      createFormRules: {
        project_name: [
          { required: true, message: '请输入项目名称', trigger: 'blur' },
          { min: 2, max: 255, message: '长度在 2 到 255 个字符', trigger: 'blur' },
        ],
        project_type: [{ required: true, message: '请选择项目类型', trigger: 'change' }],
        customer_name: [{ required: true, message: '请选择或输入客户名称', trigger: 'change' }],
        solution_manager: [{ required: true, message: '请选择方案负责人', trigger: 'change' }],
        project_manager: [{ required: true, message: '请选择项目负责人', trigger: 'change' }],
        project_location: [{ required: true, message: '请输入项目地点', trigger: 'blur' }],
        plan_date: [{ required: true, message: '请选择方案日期', trigger: 'change' }],
        list_date: [{ required: true, message: '请选择清单日期', trigger: 'change' }],
        project_desc: [{ required: true, message: '请输入项目描述', trigger: 'blur' }],
        filename: [{ required: false }],
        auditor: [{ required: true, message: '请选择审核人员', trigger: 'change' }],
      },
      debouncedExport: null,
      projects: [],
      searchForm: {
        create_time: [],
        project_type: '',
        project_name: '',
        customer_name: '',
        project_location: '',
        plan_date: '',
        list_date: '',
        audit_status: '',
        creator: '',
        operation_status: '',
        operation_flag: '',
      },
      projectTypeOptions: [
        { value: '框架', label: '框架' },
        { value: '零星', label: '零星' },
        { value: '专项', label: '专项' },
      ],
      customerOptions: [
        { value: '腾讯', label: '腾讯' },
        { value: '阿里', label: '阿里' },
        { value: '秦淮', label: '秦淮' },
        { value: '字节', label: '字节' },
        { value: '快手', label: '快手' },
        { value: '传音', label: '传音' },
        { value: '其它', label: '其它' },
      ],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      showColumnsDialog: false,
      selectedColumns: [
        'project_name',
        'project_type',
        'customer_name',
        'solution_manager',
        'project_manager',
        'project_location',
        'create_time',
        'plan_date',
        'list_date',
        'project_desc',
        'creator',
        'audit_opinion',
        'audit_time',
        'auditor',
        'attachments',
        'remark',
        'audit_status',
        'modify_date',
      ],
      defaultSelectedColumns: [
        'project_name',
        'project_type',
        'customer_name',
        'solution_manager',
        'project_manager',
        'project_location',
        'create_time',
        'plan_date',
        'list_date',
        'project_desc',
        'creator',
        'audit_opinion',
        'audit_time',
        'auditor',
        'attachments',
        'remark',
        'audit_status',
        'modify_date',
      ],
      columns: [
        { prop: 'customer_name', label: '客户名称', width: 80 },
        { prop: 'project_location', label: '项目地点', width: 150 },
        { prop: 'creator', label: '创建人', width: 80 },
        { prop: 'solution_manager', label: '方案负责人', width: 90 },
        { prop: 'project_manager', label: '项目负责人', width: 90 },
        { prop: 'create_time', label: '创建日期', width: 100 },
        { prop: 'modify_date', label: '修改日期', width: 100 },
        { prop: 'project_type', label: '项目类型', width: 80 },
        { prop: 'audit_status', label: '项目状态', width: 100 },
        { prop: 'remark', label: '备注' },
        // { prop: 'attachments', label: '附件', showOverflowTooltip: false },
      ],
      visibleColumns: [],
      selectedRows: [],
      machineList: [],
      loading: false,
      userList: [],
      isStaff: false,
    };
  },
  async created() {
    await this.getStaffInfos();
    if (this.isStaff) {
      this.visibleColumns = this.columns.filter((column) =>
        this.selectedColumns.includes(column.prop)
      );
      const now = this.$moment();
      const startDate = now.clone().startOf('month').format('YYYY-MM-DD');
      const endDate = now.clone().endOf('month').format('YYYY-MM-DD');
      this.searchForm.create_time = [startDate, endDate];
      this.handleDateChange(this.searchForm.create_time);
      this.fetchProjectList();
      // 创建防抖后的导出函数
      this.debouncedExport = debounce(this.handleExport, 300);
    }
  },
  mounted() {
    this.loginName = localStorage.getItem('UserId');
  },
  methods: {
    async getStaffInfos() {
      try {
        const res = await getStaffInfo();
        if (res.data.code === 200) {
          this.userList = res.data.data.data;
          const userId = localStorage.getItem('UserId');
          this.isStaff = this.userList.some((user) => user.username === userId);
        }
      } catch (error) {
        this.isStaff = false;
      }
    },
    async handleFileDownload(file) {
      try {
        const fileName = file.file_name;
        console.log('Downloading file:', fileName);

        // 使用 axios 获取文件
        const response = await axios({
          url: '/api/v1/ops/download',
          method: 'GET',
          params: {
            url: file.file_path,
            filename: fileName,
          },
          responseType: 'blob',
        });

        // 创建 Blob URL
        const blobUrl = window.URL.createObjectURL(response.data);

        // 创建下载链接
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = fileName;
        link.setAttribute('download', fileName);

        document.body.appendChild(link);
        link.click();

        // 清理
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);

        this.$message.success(`文件 ${fileName} 开始下载`);
      } catch (error) {
        console.error('文件下载失败:', error);
        this.$message.error('文件下载失败，请重试');
      }
    },

    async handleFileSaveAs(file) {
      try {
        const fileName = file.file_name;

        // 使用 File System Access API 保存文件
        if (window.showSaveFilePicker) {
          const options = {
            suggestedName: fileName,
            types: [
              {
                description: '所有文件',
              },
            ],
          };

          // 通过后端代理获取文件内容
          const response = await axios({
            url: '/api/v1/ops/download',
            method: 'GET',
            params: {
              url: file.file_path,
              filename: fileName,
            },
            responseType: 'blob',
          });

          // 保存文件
          const handle = await window.showSaveFilePicker(options);
          const writable = await handle.createWritable();
          await writable.write(response.data);
          await writable.close();

          this.$message.success('文件已成功保存到指定目录！');
        } else {
          // 降级方案：使用传统下载方式
          const link = document.createElement('a');
          link.href = `/api/download?url=${encodeURIComponent(
            file.file_path
          )}&filename=${encodeURIComponent(fileName)}`;
          link.download = fileName;

          // 设置下载属性
          link.setAttribute('download', fileName);
          link.setAttribute('target', '_blank');

          // 添加到文档中并触发点击
          document.body.appendChild(link);
          link.click();

          // 清理DOM
          setTimeout(() => {
            document.body.removeChild(link);
          }, 100);

          this.$message.success('文件已开始下载！');
        }
      } catch (error) {
        console.error('文件保存失败:', error);
        let errorMessage = '文件保存失败';

        if (error.name === 'AbortError') {
          errorMessage = '用户取消了保存操作';
        } else if (error.name === 'SecurityError') {
          errorMessage = '由于安全限制，无法保存文件';
        } else if (error.name === 'NotAllowedError') {
          errorMessage = '没有保存文件的权限';
        } else if (error.message.includes('Network Error')) {
          errorMessage = '网络错误，请检查网络连接';
        }

        this.$message.error(errorMessage);
      }
    },
    openCreateDrawer() {
      this.createDrawerVisible = true;
    },
    handlePreview(file) {
      window.open(file.url);
    },
    // 处理文件下载和打开

    handleRemove(file, fileList) {
      this.createForm.attachments = fileList;
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    // 处理文件上传
    handleUpload(options) {
      const { file } = options;

      // 校验文件大小
      const isLtMaxSize = file.size / 1024 / 1024 < 50;
      if (!isLtMaxSize) {
        this.$message.error(`上传文件大小不能超过 ${this.maxFileSize}MB!`);
        return;
      }

      // 将文件添加到fileList
      this.createForm.attachments.push({
        name: file.name,
        raw: file,
      });

      // 触发上传成功回调
      options.onSuccess();
    },
    // 上传成功回调
    handleUploadSuccess(response, file, fileList) {
      if (response.code === 200) {
        this.createForm.attachments = fileList;
        this.$message.success('上传成功');
      } else {
        this.$message.error(response.msg || '上传失败');
      }
    },
    beforeRemove(file) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleCustomerChange(value) {
      this.createForm.isCustomCustomer = value === 'other';
      if (!this.createForm.isCustomCustomer) {
        const selectedCustomer = this.customerOptions.find((item) => item.value === value);
        this.createForm.customerName = selectedCustomer ? selectedCustomer.label : '';
      } else {
        this.createForm.customerName = '';
      }
    },
    submitCreateForm() {
      this.$refs.createForm.validate(async (valid) => {
        if (valid) {
          try {
            this.loading = true;
            // 构建FormData
            const formData = new FormData();
            formData.append('project_name', this.createForm.project_name);
            formData.append('project_type', this.createForm.project_type);
            formData.append('customer_name', this.createForm.customer_name);
            formData.append('solution_manager', this.createForm.solution_manager);
            formData.append('project_manager', this.createForm.project_manager);
            formData.append('project_location', this.createForm.project_location);
            formData.append('plan_date', this.createForm.plan_date);
            formData.append('list_date', this.createForm.list_date);
            formData.append('project_desc', this.createForm.project_desc);
            formData.append('creator', localStorage.getItem('UserId') || '匿名用户');
            formData.append('auditor', this.createForm.auditor || '匿名用户');
            formData.append('audit_status', '提交方案');
            formData.append('operation_status', '1');
            formData.append('operation_flag', '未处理');

            if (this.createForm.attachments && this.createForm.attachments.length > 0) {
              formData.append('filename', this.createForm.attachments[0].name);
            }

            // 添加文件到FormData
            if (this.createForm.attachments.length > 0) {
              this.createForm.attachments.forEach((file) => {
                formData.append('files', file.raw);
              });
            }

            // 提交表单和附件
            const response = await createTechnicalReform(formData);
            if (response.data.code === 200) {
              this.$message.success('创建项目成功');
              this.createDrawerVisible = false;
              this.fetchProjectList();
              this.$refs.createForm.resetFields();
              this.createForm.attachments = [];
            } else {
              throw new Error(response.message || '创建项目失败');
            }
          } catch (error) {
            console.error('创建项目失败:', error);
            this.$message.error(`创建项目失败: ${error.message || '未知错误'}`);
          } finally {
            this.loading = false;
          }
        } else {
          return false;
        }
      });
    },
    handleDateChange(dates) {
      if (dates) {
        this.searchForm.startTime = dates[0];
        this.searchForm.endTime = dates[1];
      } else {
        this.searchForm.startTime = '';
        this.searchForm.endTime = '';
      }
      this.fetchProjectList();
    },
    getMachineLists() {
      const params = {
        page: this.currentPage,
        size: this.pageSize,
      };
      getMachineList(params)
        .then((res) => {
          this.machineList = res.data.data.list || [];
        })
        .catch(() => {
          this.$message.error(errorMessage);
        });
    },
    async fetchProjectList() {
      this.loading = true;
      try {
        const params = {
          skip: this.currentPage,
          limit: this.pageSize,
        };

        // 只添加有值的搜索条件
        Object.keys(this.searchForm).forEach((key) => {
          const value = this.searchForm[key];
          if (value !== '' && value !== null && value !== undefined) {
            if (Array.isArray(value) && value.length > 0) {
              params[key] = value;
            } else if (!Array.isArray(value)) {
              params[key] = value;
            }
          }
        });

        const response = await getTechnicalReformList(params);
        if (response.data.code === 200) {
          this.projects = response.data.data.list || [];
          this.total = response.data.data.total || 0;
        } else {
          this.$message.error(response.message || '获取项目列表失败');
        }
      } catch (error) {
        console.error('获取项目列表失败:', error);
        this.$message.error('获取项目列表失败');
      } finally {
        this.loading = false;
      }
    },
    handleSearch() {
      this.currentPage = 1;
      this.fetchProjectList();
    },

    handleReset() {
      this.searchForm = {
        create_time: [],
        project_type: '',
        project_name: '',
        customer_name: '',
        project_location: '',
        plan_date: '',
        list_date: '',
        audit_status: '',
        creator: '',
        operation_status: '',
        operation_flag: '',
      };
      this.fetchProjectList();
    },
    openColumnsDialog() {
      this.showColumnsDialog = true;
    },
    saveColumnsDialog() {
      this.showColumnsDialog = false;
      this.visibleColumns = this.columns.filter((column) =>
        this.selectedColumns.includes(column.prop)
      );
    },
    selectAllColumns() {
      this.selectedColumns = this.columns.map((column) => column.prop);
    },
    restoreDefaultColumns() {
      this.selectedColumns = [...this.defaultSelectedColumns];
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.fetchProjectList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchProjectList();
    },
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },

    // 处理删除
    handleDelete(row) {
      this.$confirm('确定要删除该项目吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          const formData = new FormData();
          formData.append('operator', localStorage.getItem('UserId') || '匿名用户');
          deleteTechnicalReform(row.id, formData).then(() => {
            this.$message.success('删除成功');
            this.fetchProjectList();
          });
        })
        .catch(() => {
          this.$message.info('已取消删除');
        });
    },
    async handleRemarkUpdate(row) {
      try {
        await updateTechnicalReformRemark(row.id, {
          remark: row.remark,
        });
        row.isEditing = false;
        this.$message.success('备注更新成功');
      } catch (error) {
        console.error('更新备注失败:', error);
        this.$message.error('备注更新失败');
      }
    },
    handleEditRemark(row) {
      this.$set(row, 'isEditing', true);
    },

    // 确认删除
    async confirmDelete() {
      try {
        const formData = new FormData();
        formData.append('operator', localStorage.getItem('UserId') || '匿名用户');
        await deleteTechnicalReform(this.deleteRow.id, formData);
        this.$message.success('删除成功');
        this.deleteDialogVisible = false;
        this.fetchProjectList();
      } catch (error) {
        this.$message.error('删除失败：' + error.message);
      }
    },
    async handleExport() {
      this.exportLoading = true;
      try {
        // 获取数据源
        let exportData = [];
        if (this.selectedRows.length === 0) {
          this.loading = true;
          const response = await getTechnicalReformListAll({
            ...Object.fromEntries(
              Object.entries(this.searchForm).filter(
                ([_, value]) => value !== '' && value !== null && value !== undefined
              )
            ),
            pageSize: this.total || 9999999,
            currentPage: 1,
          });
          if (response.data) {
            exportData = response.data.data.list || [];
          }
          this.loading = false;
        } else {
          exportData = this.selectedRows;
        }

        // 转换数据格式，确保与表格显示一致
        const worksheetData = exportData.map((row, index) => {
          const rowData = {};
          // 添加序号
          rowData['序号'] = index + 1;
          // 添加项目名称
          rowData['项目名称'] = row.project_name || '-';
          this.visibleColumns.forEach((column) => {
            if (column.prop !== 'operation' && column.prop !== 'project_name') {
              let value = row[column.prop];
              // 根据不同字段类型处理数据
              if (['create_time', 'plan_date', 'list_date', 'modify_date'].includes(column.prop)) {
                value = value ? this.$moment(value).format('YYYY-MM-DD') : '-';
              } else if (column.prop === 'audit_status') {
                value = value || '-';
              } else if (column.prop === 'attachments') {
                value = Array.isArray(value) ? value.map((file) => file.file_name).join(', ') : '-';
              } else {
                value = value || '-';
              }
              rowData[column.label] = value;
            }
          });
          return rowData;
        });

        // 创建工作簿和工作表
        const worksheet = XLSX.utils.json_to_sheet(worksheetData);

        // 设置列宽
        const colWidths = {};
        this.visibleColumns.forEach((column, index) => {
          const width = column.width ? Math.ceil(parseInt(column.width) / 7) : 10;
          colWidths[XLSX.utils.encode_col(index)] = { wch: width };
        });
        worksheet['!cols'] = Object.values(colWidths);

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, '技术改造');

        // 生成文件名并导出
        const timestamp = this.$moment().format('YYYYMMDDHHmmss');
        const filename = `技术改造_${timestamp}.xlsx`;
        XLSX.writeFile(workbook, filename);
        this.$message.success('导出成功');
      } catch (error) {
        console.error('导出错误:', error);
        this.$message.error('导出失败，请重试');
      } finally {
        this.exportLoading = false;
        this.loading = false;
      }
    },
  },
  computed: {
    exportButtonText() {
      return this.selectedRows.length > 0 ? `导出已选(${this.selectedRows.length})` : '导出全部';
    },
  },
  watch: {
    selectedColumns(val) {
      this.selectAll = val.length === this.columns.length;
      this.isIndeterminate = val.length > 0 && val.length < this.columns.length;
    },
  },
};
</script>
        
        <style lang="scss" scoped>
.create-form {
  padding: 20px;
}
.drawer-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 20px;
  background: #fff;
  text-align: right;
  border-top: 1px solid #e8e8e8;
}
.button-container {
  display: flex;
  gap: 10px;
  margin-bottom: 16px;
  justify-content: space-between;
}
.container {
  padding: 20px;
}
.title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 30px;
}
.search-container {
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
}

.search-form {
  width: 100%;
}

.search-button {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-left: 13px;
}

/* 调整表单项间距 */
.el-form-item {
  margin-bottom: 18px;
  display: flex;
}

.box-card {
  margin-bottom: 20px;
}
.pagination-container {
  display: flex;
  justify-content: flex-end;
}
.title-en {
  margin: 10px 0;
  padding-left: 10px;
  border-left: 3px solid #219aff;
  font-weight: normal;
}
.columns-dialog {
  margin-top: 0 !important;
  position: absolute !important;
  margin-left: 0 !important;
  top: 100% !important;
  left: 0 !important;
  transform: none !important;
}

.el-dialog__wrapper.columns-dialog {
  position: absolute !important;
  overflow: visible !important;
}

.checkbox-group {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  padding: 10px;
  max-height: 300px;
  overflow-y: auto;
}

.checkbox-item {
  margin-right: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dialog-footer {
  text-align: right;
  padding-top: 15px;
  border-top: 1px solid #ebeef5;
}

.dialog-footer .el-button + .el-button {
  margin-left: 8px;
}

/* 修改日期选择器宽度 */
::v-deep .el-date-editor.el-input__inner,
.el-date-editor--daterange.el-input__inner {
  width: 100% !important;
}

::v-deep .el-range-editor.el-input__inner {
  width: 100% !important;
}
::v-deep .el-date-editor .el-range-input {
  width: 66% !important;
}
::v-deep .el-range-editor--small .el-range-input {
  font-size: 12px !important;
}
/* 统一下拉框和输入框宽度 */
::v-deep .el-select,
.el-input {
  width: 100% !important;
}
::v-deep .el-form-item__content {
  width: calc(100% - 10px) !important;
}

/* PO单号链接样式 */
::v-deep .el-table a {
  color: #409eff;
  text-decoration: none;
  font-weight: 500;
}

.attachment-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
}

::v-deep .attachment-actions .el-button--text {
  padding: 0;
  color: #409eff;
}

::v-deep .el-table a:hover {
  color: #66b1ff;
  text-decoration: underline;
  font-weight: 500;
}
::v-deep .el-form-item__label {
  width: 120px !important;
}
.attachment-container {
  .attachment-cards {
    display: flex;
    flex-wrap: wrap;

    .attachment-card {
      display: flex;
      align-items: center;
      padding: 5px 12px;
      border-radius: 6px;
      transition: all 0.3s;
      cursor: pointer;

      &:hover {
        background: #e6e8eb;
        transform: translateY(-2px);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      }

      .file-icon {
        font-size: 14px;
        color: #409eff;
        margin-right: 12px;
      }

      .file-info {
        .file-name {
          font-size: 12px;
          color: #303133;
          margin-bottom: 8px;
          max-width: 200px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          &:hover {
            color: #409eff;
          }
        }

        .file-actions {
          display: flex;
          gap: 8px;

          .el-button {
            padding: 0;
            font-size: 12px;

            &:hover {
              color: #409eff;
            }
          }
        }
      }
    }
  }
}

.no-attachment {
  color: #909399;
}
::v-deep .el-divider__text,
.el-image__error,
.el-link,
.el-timeline,
.el-transfer__button i,
.el-transfer__button span {
  font-size: 12px !important;
}
</style>